(() => {
  const blocked = /\b(?:pot|bo[iî]te)s?\b/i;
  const sachet = /sachet/i;
  const rootSelector = 'variant-picker, variant-selects, product-form, form[action*="/cart/add"]';
  const textOf = (el) => ((el && (el.getAttribute('value') || el.textContent || el.value)) || '').replace(/\s+/g, ' ').trim();

  function cleanPicker(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('select').forEach((select) => {
      const options = Array.from(select.options);
      options.forEach((option) => {
        if (blocked.test(textOf(option))) {
          option.disabled = true;
          option.hidden = true;
        }
      });
      const current = select.selectedOptions && select.selectedOptions[0];
      if (current && blocked.test(textOf(current))) {
        const next = options.find((option) => sachet.test(textOf(option)) && !option.disabled);
        if (next) {
          select.value = next.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });

    root.querySelectorAll('input[type="radio"]').forEach((input) => {
      const label = (input.id && root.querySelector('label[for="' + CSS.escape(input.id) + '"]')) || input.closest('label');
      const valueText = [input.value, textOf(label)].filter(Boolean).join(' ');
      if (blocked.test(valueText)) {
        if (label) label.style.setProperty('display', 'none', 'important');
        input.disabled = true;
        if (input.checked) {
          const candidates = Array.from(root.querySelectorAll('input[type="radio"]'));
          const replacement = candidates.find((candidate) => {
            const candidateLabel = (candidate.id && root.querySelector('label[for="' + CSS.escape(candidate.id) + '"]')) || candidate.closest('label');
            const candidateText = [candidate.value, textOf(candidateLabel)].join(' ');
            return candidate.name === input.name && sachet.test(candidateText) && !blocked.test(candidateText);
          });
          if (replacement) {
            replacement.checked = true;
            replacement.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    });

    root.querySelectorAll('button, [role="radio"], label, .variant-option, .swatch').forEach((el) => {
      if (blocked.test(textOf(el)) && !el.querySelector('input[type="radio"]')) {
        el.style.setProperty('display', 'none', 'important');
      }
    });
  }

  function run() {
    document.querySelectorAll(rootSelector).forEach(cleanPicker);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();

  const observer = new MutationObserver(run);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', run);
})();